import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl }     from '@angular/forms';

@Pipe ({ standalone: true, name: 'ErrorInTemplate' })
export class ErrorInTemplatePipe implements PipeTransform {
  transform (control: AbstractControl): boolean {
    return control.invalid && control.touched;
  }
}
